export default [
  {
    text: 'Participation in the international scientific conference <a href="https://openreadings.eu/">OpenReadings</a> in Vilnius.',
    year: '2026',
  },
  {
    text: 'Membership at <a href="https://home.cern/about/who-we-are/our-governance">CERN</a> during the summer of 2024.',
    year: '2024',
  },
  { text: 'Acert B2 English language certificate', year: '2024' },
  {
    text: 'Scholarship as part of the <a href="https://www.stypendia-pomostowe.pl">Bridge Scholarships</a> program.',
    year: '2023',
  },
  {
    text: 'Scholarship awarded again under the <a href="https://www.podparpackie.edu.pl">Scholarship support for gifted students</a> program.',
    year: '2022',
  },
  {
    text: 'The <a href="https://soulgraphy.me">Soulgraphy</a> project reached 100,000 page views online.',
    year: '2021',
  },
  {
    text: 'Scholarship under the <a href="https://www.podparpackie.edu.pl">Scholarship support for gifted students</a> program.',
    year: '2020',
  },
  {
    text: 'Laureate of the nationwide "Albus" physics competition (8th place).',
    year: '2019',
  },
  { text: 'Laureate of the regional physics competition.', year: '2019' },
  {
    text: 'Double laureate of the nationwide "Olimpus" competition in mathematics (5th place) and physics (9th place).',
    year: '2019',
  },
]
